@use '../../styles/global' as *;
@use '../../styles/kol-alert-mixin' as *;
@use '../../styles/kol-form-field-mixin' as *;
@use '../../styles/kol-input-container-mixin' as *;
@use '../../styles/kol-input-mixin' as *;
@use '../@shared/mixins' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-form-field;
	@include kol-input-container;
	@include kol-input;
}
